import classNames from "classnames";
import { FC } from "react";
import styles from "./CircleLoader.module.scss";

interface Props {
  isLoading?: boolean;
  colorType?: "light" | "dark";
  className?: string;
}

const CircleLoader: FC<Props> = ({
  isLoading,
  colorType = "light",
  className,
}) => {
  if (!isLoading) return null;

  return (
    <div
      className={classNames(styles.loader, className)}
      data-color={colorType}
    ></div>
  );
};

export default CircleLoader;
